import apiClient, { transformResponse } from './client';
import { API_ENDPOINTS } from '@/utils/constants';
import type {
  ApiResponse,
  SignupRequest,
  SigninRequest,
  VerifyOtpRequest,
  ResendOtpRequest,
  ConfirmPasswordResetRequest,
  AuthResponse,
  ResendOtpResponse,
  PasswordResetResponse,
} from '@/types';

export const authApi = {
  signup: async (data: SignupRequest) => {
    const res = await apiClient.post<ApiResponse<{ email: string }>>(
      API_ENDPOINTS.AUTH.SIGNUP,
      data,
    );
    return transformResponse(res);
  },

  signin: async (data: SigninRequest) => {
    const res = await apiClient.post<ApiResponse<AuthResponse>>(
      API_ENDPOINTS.AUTH.SIGNIN,
      data,
    );
    return transformResponse(res);
  },

  verifyOtp: async (data: VerifyOtpRequest) => {
    const res = await apiClient.post<ApiResponse<AuthResponse>>(
      API_ENDPOINTS.AUTH.VERIFY_OTP,
      data,
    );
    return transformResponse(res);
  },

  resendOtp: async (data: ResendOtpRequest) => {
    const res = await apiClient.post<ApiResponse<ResendOtpResponse>>(
      API_ENDPOINTS.AUTH.RESEND_OTP,
      data,
    );
    return transformResponse(res);
  },

  requestPasswordReset: async (email: string) => {
    const res = await apiClient.post<ApiResponse<PasswordResetResponse>>(
      API_ENDPOINTS.AUTH.RESET_PASSWORD_REQUEST,
      { email },
    );
    return transformResponse(res);
  },

  confirmPasswordReset: async (data: ConfirmPasswordResetRequest) => {
    const res = await apiClient.post<ApiResponse<PasswordResetResponse>>(
      API_ENDPOINTS.AUTH.RESET_PASSWORD_CONFIRM,
      data,
    );
    return transformResponse(res);
  },

  refreshToken: async () => {
    const res = await apiClient.post<ApiResponse<AuthResponse>>(
      API_ENDPOINTS.AUTH.REFRESH_TOKEN,
    );
    return transformResponse(res);
  },

  logout: async () => {
    const res = await apiClient.post<ApiResponse<{ message: string }>>(
      API_ENDPOINTS.AUTH.LOGOUT,
    );
    return transformResponse(res);
  },

  exchangeCode: async (code: string) => {
    const res = await apiClient.post<ApiResponse<AuthResponse>>(
      API_ENDPOINTS.AUTH.EXCHANGE,
      { code },
    );
    return transformResponse(res);
  },
};
